export default class InscriptionSummary extends HTMLDivElement {

    constructor() {
        super();
        this.$input = this.querySelector('#btnAddDriver');
        this.cgvIsChecked = false;
        this.ppdpIsChecked = false;
        this.cgctcapIsChecked = false;
    }

    connectedCallback() {
        let self = this;

        $("#cgv").change(function () {
            if (this.checked) {
                self.cgvIsChecked = true;
            }
            else {
                self.cgvIsChecked = false;
            }

            self.EnableSubmitButton();
        });

        $("#cg-ct-cap").change(function () {
            if (this.checked) {
                self.cgctcapIsChecked = true;
            }
            else {
                self.cgctcapIsChecked = false;
            }

            self.EnableSubmitButton();
        });

        $("#ppdp").change(function () {
            if (this.checked) {
                self.ppdpIsChecked = true;
            }
            else {
                self.ppdpIsChecked = false;
            }

            self.EnableSubmitButton();
        });
    }

    EnableSubmitButton() {
        if (this.cgvIsChecked && this.ppdpIsChecked && this.cgctcapIsChecked) {
            $("#validate").removeAttr('disabled').removeClass('disabled');
        }
        else {
            $("#validate").attr('disabled', '').addClass('disabled');
        }
    };

}